import { styled } from "@mui/material/styles";
import { DialogTitle } from "@mui/material";

export const DialogTitleStyled = styled(DialogTitle)(({theme}) => ({
	borderBottomWidth: '1px',
	borderBottomStyle: 'solid',
	borderBottomColor: theme.palette.secondary.main,
}))
